import moment from 'moment';

export const formatDay = (day, format) => {
  return moment(day).format(format)
};
